import React from 'react';
export function TangibilitySection() {
  return <section className="py-10 px-5" style={{
    backgroundColor: '#0F3C3C'
  }} data-id="element-279">
      <div className="max-w-lg mx-auto text-center" data-id="element-280">
        {/* Header Micro-Copy */}
        <p className="text-sm font-bold tracking-widest uppercase mb-2" style={{
        color: '#D4AF37'
      }} data-id="element-281">
          ASÍ SE VE EL CAMBIO POR DENTRO
        </p>
        <h2 className="text-xl md:text-2xl font-bold text-white mb-1 leading-tight" data-id="element-282">
          Módulo 2: El Posicionamiento Estratégico
        </h2>
        <p className="text-white/60 italic text-sm mb-6" data-id="element-283">
          Contenido real diseñado para tu móvil y tablet
        </p>

        {/* Image with Outer Glow */}
        <div className="w-full mb-6 relative flex justify-center" data-id="element-284">
          <div className="absolute inset-0 flex items-center justify-center -z-10" data-id="element-285">
            <div className="w-4/5 h-4/5 rounded-full blur-3xl opacity-30" style={{
            backgroundColor: '#D4AF37'
          }} data-id="element-286"></div>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/1b915X1BaTfWkqf7vEZV2U/Diseno_sin_titulo_(1).png" alt="Módulo 2 - El Posicionamiento Estratégico en tablet y móvil" className="w-full max-w-md h-auto rounded-2xl drop-shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-id="element-287" />
        </div>

        {/* Icon Row */}
        <div className="flex items-center justify-center gap-5 flex-wrap" data-id="element-288">
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{
          color: '#D4AF37'
        }} data-id="element-289">
            📱 Móvil
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{
          color: '#D4AF37'
        }} data-id="element-290">
            💻 Tableta / PC
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{
          color: '#D4AF37'
        }} data-id="element-291">
            📥 Entrega Inmediata
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium" style={{
          color: '#D4AF37'
        }} data-id="element-292">
            ⏱️ 10 min/día
          </span>
        </div>
      </div>
    </section>;
}